<template>
  <div class="threeview">
    <div class="selectview">
      <el-row>
        <el-col :span="21">
          <ul class="ullist">
            <li class="liwidth_select">
              <el-select
                v-model="province_value"
                clearable
                placeholder="请选择省份"
                @change="getcitys(province_value)"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.province"
                  :label="item.province"
                  :value="item.province"
                ></el-option>
              </el-select>
            </li>
            <li class="liwidth_select">
              <el-select
                v-model="city_value"
                clearable
                placeholder="请选择城市"
                @change="getStations(city_value)"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.city"
                  :label="item.city"
                  :value="item.city"
                ></el-option>
              </el-select>
            </li>
            <li>
              <el-select
                v-model="station_value"
                clearable
                placeholder="请选择场站"
                @change="getchargers(station_value)"
              >
                <el-option
                  v-for="item in stationList"
                  :key="item.station_id"
                  :label="item.station_name"
                  :value="item.station_id"
                ></el-option>
              </el-select>
            </li>
            <li>
              <el-select
                v-model="charger_value"
                clearable
                placeholder="请选择充电桩"
              >
                <el-option
                  v-for="item in chargerlist"
                  :key="item.charger_id"
                  :label="item.charger_id"
                  :value="item.charger_id"
                ></el-option>
              </el-select>
            </li>
            <li class="liwidth_select">
              <el-select v-model="to_type" clearable placeholder="请选择类型">
                <el-option
                  v-for="item in typelist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </li>
            <li class="liwidth_date">
              <el-date-picker
                v-model="start_date"
                type="date"
                placeholder="选择开始日期"
              ></el-date-picker>
            </li>
            <li class="liwidth_date">
              <el-date-picker
                v-model="end_date"
                type="date"
                placeholder="选择结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </li>
            <li>
              <el-input
                placeholder="请输入用户openid"
                v-model="id_input"
                clearable
              ></el-input>
            </li>
            <li style="width: 150px">
              <el-select
                v-model="start_way"
                clearable
                placeholder="请选择启动方式"
              >
                <el-option
                  v-for="item in ChWaylist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </li>
            <li class="liwidth_select">
              <el-select v-model="successorfail" clearable placeholder="动作">
                <el-option
                  v-for="item in successorfailList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </li>
            <div style="clear: both"></div>
          </ul>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" class="querybutton" @click="searchClick()"
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div class="tabelview">
      <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
        style="width: 100%"
      >
        <el-table-column
          align="left"
          prop="id"
          label="日志ID"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="charger_id"
          label="充电桩编号"
          width="150"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="station_name"
          label="场站名称"
          width="230"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="nickname"
          label="微信用户昵称"
          width="230"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="gun_no"
          label="枪号"
        ></el-table-column>
        <el-table-column align="left" prop="type" label="类型">
          <template slot-scope="scope">
            <span class="start-charging" v-if="scope.row.type == '1'"
              >启动充电</span
            >
            <span class="end-charging" v-else-if="scope.row.type == '2'"
              >结束充电</span
            >
          </template>
        </el-table-column>
        <el-table-column align="left" prop="method" label="充电方式">
          <template slot-scope="scope">
            <span class="mobile-scanner" v-if="scope.row.method == '1'"
              >手机扫码</span
            >
            <span class="charging-code" v-else-if="scope.row.method == '2'"
              >充电码</span
            >
          </template>
        </el-table-column>
        <el-table-column align="left" prop="data" label="成功/失败" width="100">
          <template slot-scope="scope">
            <span class="success" v-if="scope.row.data == '1'">成功</span>
            <span class="fail" v-else-if="scope.row.data == '2'">失败</span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          prop="fail_detail"
          label="失败详情"
          width="120"
        >
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.fail_detail == '' || scope.row.fail_detail == null
              "
              >--</span
            >
            <span v-else-if="scope.row.fail_detail == '1'">桩故障</span>
            <span v-else-if="scope.row.fail_detail == '2'">未插枪</span>
            <span v-else-if="scope.row.fail_detail == '3'">充电桩被占用</span>
            <span v-else-if="scope.row.fail_detail == '4'">超时没回应</span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          prop="openid"
          label="微信用户openid"
          width="250"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="timestamp"
          label="时间"
          width="180"
        ></el-table-column>
      </el-table>
    </div>

    <div class="cutpagesview">
      <el-pagination
        class="pageinclass"
        background
        :page-size="pagesize"
        :page-count="pagecount"
        :current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="prev, pager, next,jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      total: 10, //这个是总共有多少条数据
      pagesize: 20, //每页显示条目个数
      currentPage: 1, //当前页数
      pagecount: 10, //页码按钮的数量

      province_value: "", //选择省份
      provinceList: [], //省份列表
      cityList: [], //城市列表
      city_value: "", //选择城市
      stationList: [], //场站列表
      station_value: "", //选择场站
      chargerlist: [], //充电桩列表
      charger_value: "", //选择充电桩
      start_date: "", //开始日期
      end_date: "", //结束日期

      id_input: "", //用户id

      to_type: "", //类型
      typelist: [
        {
          value: 1,
          label: "启动充电",
        },
        {
          value: 2,
          label: "结束充电",
        },
      ],
      start_way: "", //充电方式
      ChWaylist: [
        {
          value: 1,
          label: "手机扫码",
        },
        {
          value: 2,
          label: "充电码",
        },
      ],
      successorfail: "", //成功/失败
      successorfailList: [
        {
          value: 1,
          label: "成功",
        },
        {
          value: 2,
          label: "失败",
        },
      ],

      tableData: [],
      pickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() < this.start_date || time.getTime() > Date.now()
          );
        },
      },
    };
  },
  mounted() {
    this.getprovinces();

    var timestamp = new Date().getTime(); //毫秒
    // timestamp = timestamp - 7 * 24 * 3600 * 1000;
    if (this.$store.state.monthDay == 2) {
      var d = new Date(timestamp);
      let start_date =
        d.getFullYear() +
        "-" +
        this.checkTime(d.getMonth()) +
        "-" +
        this.checkTime(d.getDate());

      this.start_date = start_date;
    } else {
      var d = new Date(timestamp);
      let start_date =
        d.getFullYear() +
        "-" +
        this.checkTime(d.getMonth() + 1) +
        "-" +
        this.checkTime(d.getDate());

      this.start_date = start_date;
    }
    var d1 = new Date();
    let end_date =
      d1.getFullYear() +
      "-" +
      this.checkTime(d1.getMonth() + 1) +
      "-" +
      this.checkTime(d1.getDate());
    this.end_date = end_date;

    this.province_value = this.$store.state.provinceValue;
    this.city_value = this.$store.state.cityValue;
    this.getStations1(this.city_value);
    this.querybtnClick();
  },
  methods: {
    /**
     * 获取省份数据列表
     */
    getprovinces() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };

      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            // console.log("省份列表--：", su.data.list);
            this.provinceList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    /**
     * 获取城市列表
     */
    getcitys(province_value) {
      this.city_value = "";
      this.cityList = [];
      this.station_value = "";
      this.charger_value = "";
      this.$store.commit("CityValue", "");
      this.$store.commit("StationValue", "");
      this.$store.commit("ProvinceValue", province_value);

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province: province_value,
      };

      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            //  console.log("市列表--：",su.data.list)
            this.cityList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == -1) {
            this.$message.warning("没有选择省份");
          }
        })
        .catch((err) => {});
    },

    /**
     * 获取场站列表
     */
    getStations(city_value) {
      //    console.log(this.cityList)
      this.station_value = "";
      this.stationList = [];
      this.charger_value = "";
      this.$store.commit("CityValue", city_value);
      this.$store.commit("StationValue", "");

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: city_value,
      };
      //   console.log("场站列表传值---：",params,)
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.stationList = su.data.list;
            // console.log("场站信息--：", this.stationList);
          } else if (su.data.code == 0) {
            //数据库操作失败
            this.$message.warning(su.data.message);
          } else if (su.data.code == -1) {
            this.$message.warning("没有选择城市");
          }
        })
        .catch((err) => {});
    },

    getStations1(city_value) {
      var that = this;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: city_value,
      };
      //   console.log("场站列表传值---：",params,)
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            su.data.list.map((item) => {
              if (this.$store.state.stationValue == item.station_id) {
                this.station_value = item.station_name;
              }
            });
          }
        })
        .catch((err) => {});
    },
    /**
     * 获取充电桩
     */
    getchargers(station_value) {
      this.charger_value = "";
      this.chargerlist = [];
      this.$store.commit("StationValue", station_value);

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: station_value,
      };

      // console.log(params);
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_chargers",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          // console.log("充电桩信息--：", su);
          if (su.data.code == 1) {
            // console.log("充电桩信息--：",su)
            this.chargerlist = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning("查询充电桩信息失败");
          } else if (su.data.code == -1) {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },

    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },

    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      var value = String(val);
      this.querybtnClick(value);
    },
    /**
     * 筛选启停日志
     */
    querybtnClick(page) {
      this.tableData = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getChargerGunRunningLogs",
        station_id:this.$store.state.stationValue
      };
      if (page != "" && page != null) {
        params.page = page;
      }
      if (this.province_value != "") {
        params.province = this.province_value;
      }
      if (this.city_value != "") {
        params.city = this.city_value;
      }
      // if (this.station_value != "") {
      //   params.station_id = this.station_value;
      // }
      if (this.charger_value != "") {
        params.charger_id = this.charger_value;
      }
      if (this.to_type != "") {
        params.type = this.to_type;
      }
      if (this.start_date != "" && this.start_date != null) {
        var d = new Date(this.start_date);
        // console.log("开始时间--：",d)
        let start_date =
          d.getFullYear() +
          "-" +
          this.checkTime(d.getMonth() + 1) +
          "-" +
          this.checkTime(d.getDate());
        this.start_date = start_date;
        params.start_date = start_date;

        //最后显示yyyy-MM-dd
      }
      if (this.end_date != "" && this.end_date != null) {
        var d1 = new Date(this.end_date);
        // console.log("结束时间--：",d1)
        let end_date =
          d1.getFullYear() +
          "-" +
          this.checkTime(d1.getMonth() + 1) +
          "-" +
          this.checkTime(d1.getDate());
        //最后显示yyyy-MM-dd
        // console.log("结束时间++++--：",end_date)
        this.end_date = end_date;
        params.end_date = end_date;
      }
      if (this.id_input != "") {
        params.openid = this.id_input;
      }
      if (this.start_way != "") {
        params.method = this.start_way;
      }
      if (this.successorfail != "") {
        params.data = this.successorfail;
      }

      // console.log("启停筛选传参--：", params);

      if (this.start_date > this.end_date) {
        this.$message.warning("结束日期不能小于开始日期");
      } else {
        this.$api({
          method: "post",
          url: "/api.php/AlarmManage/index",
          data: params,
          transformRequest: [
            (data) => {
              let ret = "";
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  "=" +
                  encodeURIComponent(data[it]) +
                  "&";
              }
              return ret;
            },
          ],
        })
          .then((su) => {
            // console.log("su--：", su);
            if (su.data.code == 1) {
              let datalist = su.data.list;
              // this.total = datalist.length;
              // this.pagecount = parseInt(datalist.length / 8 + 1);
              this.tableData = datalist;
              if (su.data.count == "" || su.data.count == null) {
              } else {
                this.total = su.data.count;
                this.currentPage = 1;
                // this.pagecount = su.data.count / 20;
                if (su.data.count % 20 == 0) {
                  this.pagecount = parseInt(su.data.count / 20);
                } else {
                  this.pagecount = parseInt(su.data.count / 20 + 1);
                }
              }
            } else if (su.data.code == 300) {
              //登陆过期
              localStorage.clear();
              this.$router.push("/login");
              this.$message.warning(su.data.message);
            } else if (su.data.code == 0) {
              this.total = 0;
              this.pagecount = 1;
              this.$message.warning(su.data.message);
            } else if (su.data.code == -1) {
              this.total = 0;
              this.pagecount = 1;
              this.$message.warning(su.data.message);
            }
          })
          .catch((err) => {});
      }
    },
    searchClick() {
      this.total = 10;
      this.pagesize = 20;
      this.currentPage = 1;
      this.pagecount = 10;
      this.querybtnClick();
    },
  },
};
</script>
<style scoped lang="scss">
.threeview {
  padding: 1%;
  background-color: white;
  .el-button--primary:focus,
  .el-button--primary:hover {
    background: #0071bd;
    border-color: #0071bd;
    color: #fff;
  }
}

.ullist {
  list-style-type: none;
  padding: 0;
  li {
    float: left;
    // display: inline-block;
    margin: 5px 5px 5px 0px;
  }
}

.liwidth_select {
  width: 120px;
}
.liwidth_input {
  width: 180px;
}
.liwidth_date {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 150px !important;
  }
}

.tabelview {
  margin-top: 15px;
  margin-bottom: 15px;
  .start-charging {
    color: #009a5b;
  }
  .end-charging {
    color: #e60000;
  }
  .mobile-scanner {
    color: #009a5b;
  }
  .charging-code {
    color: #0061ae;
  }
  .success {
    color: #009a5b;
  }
  .fail {
    color: #e60000;
  }
}
.el-table__row.hover-row {
  .start-charging {
    color: #ffffff;
  }
  .end-charging {
    color: #ffffff;
  }
  .mobile-scanner {
    color: #ffffff;
  }
  .charging-code {
    color: #ffffff;
  }
  .success {
    color: #ffffff;
  }
  .fail {
    color: #ffffff;
  }
}

.querybutton {
  width: 80px;
  margin: 5px 5px 5px 0px;
  text-align: center;
  display: inline-block;
  background-color: #0071bd;
  color: white;
  border: none;
}
.threeview {
  .querybutton:active {
    background-color: #409EFF;
  }
}
.cutpagesview {
  margin: 20px 0;
  height: 30px;
}
.pageinclass {
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/operationManagement/startorstopLog.vue